import React, { Component } from 'react';

import { ApiHelper } from '../../helpers/ApiHelper';
import { AppHelper } from '../../../helpers/AppHelper';
import { Helper } from '../../helpers/Helper';
import { BaseEntityPage } from '../BaseEntityPage';
import { AppStyles } from '../../../styles/AppTheme';
import { Link } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';
import { css, StyleSheet } from 'aphrodite';
import { AppConfig } from '../../../AppConfig';

export class SubSections extends BaseEntityPage {

  constructor(props) {
    super(props);
    this.pageTitle = 'Sub Sections'
    this.quizId = this.props.match.params.quizId
    this.secId = this.props.match.params.secId
    this.groupId = 'sec' + this.quizId
    this.breadCrumbs = [
      { title: 'Home', to: '/admin' },
      { title: 'Sections', to: '/admin/quiz/' + this.quizId },
      { title: 'Subsections'},
    ]
    this.toFetch = [
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['items', this.secId], { groupId: this.groupId, pb: 'fieldDef' }) },
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['items'], { parentId: this.secId, pb: 'fieldDef', groupId: this.groupId }) },
    ]
    this.tableHeadersMap = {
      'Id / Order': (current) => {return (
        <div>
          <span className={css(Styles.spanValue)}>{current.id + ' / ' + current.order}</span>
        </div>
      )},
      Retake: (current) => current.allowRetakes || 'NO',
      Title: (current) => current.title,
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      groupId: this.groupId,
      parentId: this.secId
    }
  }

  onFetchSuccess(results) {
    this.formDefinition = results[0].fieldDef;
    this.setState({
      items: Helper.sortDictArray(results[1].items),
      section: results[0]
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) {
      return ''
    }
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  disabledParentIdField() {
    for (const field of this.formDefinition.steps[0].fields) {
      if (field.key === 'parentId') {
        field.value = this.secId
        field.disabled = true
      }
    }
  }

  onAdd() {
    this.disabledParentIdField()
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['items'], { groupId: this.groupId }),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'DELETE',
      apiEndPoint: ApiHelper.makeUrlPath(['items', current.id], { groupId: this.groupId }),
    });
  }

  onEdit(current) {
    this.disabledParentIdField()
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['items', current.id], { groupId: this.groupId }),
    });
  }

  onActions = (current) => {
    const actions = []
    actions.push(AppHelper.buttonEdit(this, current))
    actions.push(
      <Link to={'/admin/quiz/' + this.quizId + '/' + this.secId + '/' + current.id} key={current.id + '-questions'}>
        <Tooltip title='Questions' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons'>question_answer</i>
          </span>
        </Tooltip>
      </Link>
    )
    actions.push(AppHelper.buttonDelete(this, current))
    return actions
  }
}

const Styles = StyleSheet.create({
})


// WEBPACK FOOTER //
// ./src/common/components/quizcreator/SubSections.js